import BaseProductListLayout from "./BaseProductListLayout";

export default function (params) {
  return BaseProductListLayout();
}
